// When running on localhost values are from: {CKLA-Hub root dir}/public/amp-config.json
import { isLocalEnvByUrl } from 'app/services/core/config.service'
import { HUB_BASE } from 'app/constants/routes.constants'
import { AmpConfig, EnvironmentFlags } from 'app/types/amp-config.types'

const ampConfig: AmpConfig = {}
const environmentFlags: EnvironmentFlags = {}

const fetchAmpConfig = async () => {
  const ampConfigPath = isLocalEnvByUrl() ? HUB_BASE : ''

  const res = await fetch(
    `${window.location.origin}${ampConfigPath}/amp-config.json`,
    {
      headers: {
        Accept: 'application/json',
      },
    }
  )

  return res.json()
}

export const fetchEnvironmentFlags = () =>
  fetchAmpConfig().then((configJson) => {
    Object.assign(ampConfig, configJson)
    Object.assign(environmentFlags, configJson.flags)
  })

export const getAmpConfig = () => ampConfig

export const isFeatureEnabled = (flag: string) =>
  environmentFlags['ckla-hub']?.[flag] ?? false
